import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { restoreAll } from '../restoreAll';

export interface ToastState {
    [id: string]: { type: string; title: string; message?: string; isHidden: boolean };
}

interface IPushToastAction {
    type: string;
    title: string;
    message?: string;
    id: string;
}

interface IPopToastAction {
    id: string;
}

const initialState: ToastState = {};

const toast = createSlice({
    name: 'toast',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        push: (state, action: PayloadAction<IPushToastAction>) => {
            const { type, title, message, id } = action.payload;
            state[id] = { type, title, message, isHidden: false };
        },
        hide: (state, action: PayloadAction<IPopToastAction>) => {
            const { id } = action.payload;
            state[id].isHidden = true;
        },
        pop: (state, action: PayloadAction<IPopToastAction>) => {
            const { id } = action.payload;
            delete state[id];
        },
    },
});

export const toastAction = toast.actions;
export default toast.reducer;
